import { render, staticRenderFns } from "./searchGame.vue?vue&type=template&id=ed0de518&scoped=true"
import script from "./searchGame.vue?vue&type=script&lang=js"
export * from "./searchGame.vue?vue&type=script&lang=js"
import style0 from "./searchGame.vue?vue&type=style&index=0&id=ed0de518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0de518",
  null
  
)

export default component.exports